module.exports = __webpack_public_path__ + "static/VTELE-42439b524b871417f302dc4be2311d4b.jpg";